export enum DashboardCalendarWidgetBlock {
  Root = 'DashboardCalendarWidget',
}
